<!-- SOLAPA «PROBAR»: preguntarle al asistente como el administrador de un comercio. -->
<div class="space-y-6 pt-2">

  <section class="kb-tarjeta">
    <div class="kb-tarjeta-cab">
      <div>
        <h2 class="flex items-center gap-2 text-base font-semibold leading-none">
          <i class="fas fa-vial text-muted-foreground" aria-hidden="true"></i>Probar el asistente del comercio
        </h2>
        <p class="m-0 mt-2 text-sm text-muted-foreground">
          Preguntas como si fueras el administrador del comercio que elijas. Corre aunque ese comercio tenga el
          asistente apagado, y queda anotado en la bitácora como «Prueba».
        </p>
      </div>
    </div>

    <div class="kb-tarjeta-cuerpo">
      <div class="grid gap-4 md:grid-cols-[minmax(0,320px)_1fr] md:items-start">
        <div>
          <label class="kb-label" for="probar-comercio">Comercio</label>
          <div class="kb-skeleton h-9 w-full" *ngIf="cargandoComercios"></div>
          <div class="kb-select-envoltorio" *ngIf="!cargandoComercios && comercios.length">
            <select id="probar-comercio" class="kb-select" [ngModel]="comercio" (ngModelChange)="cambiarComercio($event)">
              <option value="">Elige un comercio</option>
              <option *ngIf="comercio && !enLista" [value]="comercio">{{ comercio }}</option>
              <option *ngFor="let c of comercios" [value]="c.codigo">{{ c.nombre || c.codigo }} · {{ c.codigo }}</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
          <!-- Sin la lista, el código a mano: la prueba no depende de la lista. -->
          <ng-container *ngIf="!cargandoComercios && !comercios.length">
            <input id="probar-comercio" class="kb-input font-mono uppercase" type="text" placeholder="Código, p. ej. MT"
                   [ngModel]="comercio" (ngModelChange)="cambiarComercio($event)">
            <p class="kb-hint" *ngIf="errorComercios">
              No se pudo leer la lista de comercios: {{ errorComercios }} Escribe el código a mano o
              <button type="button" class="font-medium text-foreground underline underline-offset-2" (click)="cargarComercios()">reintenta</button>.
            </p>
          </ng-container>
          <p class="kb-hint" *ngIf="elegido && !elegido.habilitado">
            <i class="fas fa-info-circle mr-1" aria-hidden="true"></i>Este comercio tiene el asistente apagado: su gente no lo ve, pero la prueba corre igual.
          </p>
          <p class="kb-hint" *ngIf="elegido && elegido.habilitado">
            <i class="fas fa-check-circle mr-1" aria-hidden="true"></i>Este comercio tiene el asistente prendido.
          </p>
        </div>

        <form class="space-y-3" (ngSubmit)="preguntar()">
          <label class="kb-label" for="probar-pregunta">Pregunta</label>
          <textarea id="probar-pregunta" name="pregunta" class="kb-textarea" rows="3" maxlength="1000"
                    [(ngModel)]="pregunta" [disabled]="!comercio" (keydown)="alTeclear($event)"
                    [placeholder]="comercio ? '¿Qué quieres preguntarle?' : 'Primero elige un comercio'"></textarea>
          <div class="flex flex-wrap items-center gap-3">
            <button type="submit" class="kb-btn kb-btn-primary" [disabled]="!comercio || !pregunta.trim() || preguntando">
              <i class="fas" [ngClass]="preguntando ? 'fa-circle-notch fa-spin' : 'fa-paper-plane'" aria-hidden="true"></i>Preguntar
            </button>
            <span class="text-xs text-muted-foreground">Ctrl o Cmd + Enter también manda</span>
            <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm ml-auto" *ngIf="hilo.length" (click)="empezarDeNuevo()">
              <i class="fas fa-eraser !text-foreground" aria-hidden="true"></i>Empezar de nuevo
            </button>
          </div>
          <div class="flex flex-wrap gap-1.5" *ngIf="comercio && !hilo.length">
            <button type="button" class="kb-chip" *ngFor="let s of ARRANQUE" (click)="preguntar(s)">{{ s }}</button>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- ══ El hilo, del más viejo al más nuevo ═════════════════════════════════ -->
  <section class="kb-tarjeta" *ngFor="let t of hilo; let ultimo = last">
    <div class="kb-tarjeta-cab">
      <p class="m-0 flex items-start gap-2 text-sm font-medium">
        <i class="fas fa-user-circle mt-0.5 text-muted-foreground" aria-hidden="true"></i>{{ t.pregunta }}
      </p>
    </div>
    <div class="kb-tarjeta-cuerpo">
      <div *ngIf="!t.respuesta && !t.error && ultimo && preguntando" class="space-y-2" aria-live="polite" aria-busy="true">
        <div class="kb-skeleton h-4 w-3/4"></div>
        <div class="kb-skeleton h-4 w-1/2"></div>
      </div>
      <div class="flex flex-wrap items-center justify-between gap-3" *ngIf="t.error" role="alert">
        <p class="m-0 text-sm">
          <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
          No contestó. <span class="text-muted-foreground">{{ t.error }}</span>
        </p>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" *ngIf="ultimo" [disabled]="preguntando"
                (click)="hilo.pop(); preguntar(t.pregunta)">
          <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
        </button>
      </div>
      <app-ia-respuesta *ngIf="t.respuesta" [datos]="t.respuesta" (preguntar)="preguntar($event)"></app-ia-respuesta>
    </div>
  </section>
</div>
